import { Box, Typography } from '@mui/material'

import logo from '@/assets/images/logo.png'
import { isNullorEmpty } from '@/utils'

import DentinPDF from './pdfComponents/DentinPDF'
import EnamelPdf from './pdfComponents/EnamelPdf'
import Inputs from './pdfComponents/Inputs'
import StainingAndWashBakePDF from './pdfComponents/StainingAndWashBakePDF'
import StumpShadePDF from './pdfComponents/StumpShadePDF'

function RecipeOutPdf({
  tableKey,
  providedInputNames,
  recipeOutput,
  restorationMethodOnRecipeGenerate,
}: {
  tableKey: any
  providedInputNames: any
  recipeOutput: any
  restorationMethodOnRecipeGenerate: any
}) {
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          fontSize: '20px',
          zIndex: -1000,
        }}
        className="save-image"
      >
        <div
          className="d-flex flex-column download-pdf"
          style={{ paddingBottom: '200px', background: 'white', width: '100%' }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexGrow={1}
            p={5}
            sx={{ backgroundColor: '#FFF', color: 'black', height: '100%' }}
          >
            <Box>
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 200, height: 55, color: 'black' }}
              />
            </Box>

            <Typography variant="h1" sx={{ m: 0, fontSize: '3rem' }}>
              Shade Guide Recipe
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            flexGrow={1}
            color="black"
            sx={{
              pl: 4,
              pt: 2,
              fontWeight: 'bold',
              fontSize: '1.5rem',
              // height: '100%',
              background: 'white',
            }}
          >
            <Box>
              <Typography
                sx={{ m: 0, p: 0, fontWeight: '600', fontSize: '20px' }}
              >
                Dentist:{' '}
                <Typography
                  component="span"
                  sx={{ fontWeight: '600', fontSize: '20px' }}
                ></Typography>
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{ m: 0, p: 0, fontWeight: '600', fontSize: '20px' }}
              >
                Patient:{' '}
                <Typography
                  component="span"
                  sx={{ fontWeight: '600', fontSize: '20px' }}
                ></Typography>
              </Typography>
            </Box>
          </Box>
          <Inputs
            tableKey={tableKey}
            providedInputNames={providedInputNames}
            recipeOutput={recipeOutput}
          />
          {isNullorEmpty(recipeOutput, 'aestheticmodel_middle') && (
            <StumpShadePDF
              recipeOutput={recipeOutput}
              natural_die_material={
                recipeOutput?.provided_input?.natural_die_material
              }
            />
          )}
          {(restorationMethodOnRecipeGenerate === 'layering' ||
            restorationMethodOnRecipeGenerate === 'staining') &&
            isNullorEmpty(recipeOutput, 'stainingrecipe_middle') && (
              <StainingAndWashBakePDF
                recipeOutput={recipeOutput}
                stainingbrand={recipeOutput?.provided_input?.stainingbrand}
                restorationMethodOnRecipeGenerate={
                  restorationMethodOnRecipeGenerate
                }
              />
            )}
          {isNullorEmpty(recipeOutput, 'ceramic_recipe_middle') && (
            <DentinPDF
              recipeOutput={recipeOutput}
              brand={recipeOutput?.provided_input?.ceramicbrand}
            />
          )}
          {isNullorEmpty(recipeOutput, 'enameloptions_middle') && (
            <EnamelPdf
              recipeOutput={recipeOutput}
              brand={recipeOutput?.provided_input?.ceramicbrand}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default RecipeOutPdf
